import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 28FFD085-27EC-47A7-88A7-989BECA3DDE0
 * name bookmark-multiple
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bookmark-multiple.svg
 * tags
 */
export const BookmarkMultipleIcon = createSvgIcon(<><path d="M15,5A2,2 0 0,1 17,7V23L10,20L3,23V7C3,5.89 3.9,5 5,5H15M9,1H19A2,2 0 0,1 21,3V19L19,18.13V3H7A2,2 0 0,1 9,1Z" /></>, 'BookmarkMultipleIcon');
export default BookmarkMultipleIcon